import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { isAnonymousUser, selectUser } from "redux/authReducer";
import { resetStore } from "redux/CreateDataset/actions";
import useCreateDataset from "hooks/useCreateDataset";

import {
  CREATE_NEW_DATASET,
  SIGNUP_ORIGIN,
} from "helpers/constants/amplitudeProperties";
import { getDatasets, getLoading } from "redux/Datasets/selectors";

import ProgressBarLoaderWrapper from "views/uikit/ProgressBarLoader";
import PublicHeader from "views/components/PublicHeader";
import HealthStatus from "views/components/HealthStatus";
import DeprecatedVLButton from "views/uikit/DeprecatedVLButton";
import { isOnPremUser } from "helpers/utility/utilities";
import {
  setShowDSCreationWarning,
  setShowSignUpModal,
} from "redux/Modals/actions";
import { State } from "redux/store";

import styles from "./style.module.scss";

type HeaderProps = {
  isPrivatePath: boolean;
  datasets: any[];
  isLoading: boolean;
};

const PrivateDisplay = ({ handleButtonClick }: any) => {
  const datasetCreationEnabled = (process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || "").trim().replace(/"/g, '');
  
  return (
    <div className={styles.headerRight}>
      <HealthStatus />
      {datasetCreationEnabled === "true" && (
        <DeprecatedVLButton
          text={"+ New Dataset"}
          onClick={handleButtonClick}
          tooltipText="Create a new dataset"
        />
      )}
    </div>
  );
};

function Header({ isLoading, isPrivatePath, datasets }: HeaderProps) {
  const user = selectUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createNewDataset } = useCreateDataset();

  const handleButtonClick = async () => {
    const datasetCreationEnabled = (process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || "").trim().replace(/"/g, '');
    
    if (datasetCreationEnabled !== "true") {
      return;
    }

    // Only show on-prem warning if dataset creation from UI is NOT explicitly enabled
    if (isOnPremUser() && datasetCreationEnabled !== "true") {
      dispatch(setShowDSCreationWarning(true));
      return;
    }

    //check if user has not signed-in (only for non-onprem environments)
    if (!isOnPremUser() && (user === null || isAnonymousUser())) {
      dispatch(setShowSignUpModal(true));
      localStorage.setItem(SIGNUP_ORIGIN, CREATE_NEW_DATASET);
      return;
    }
    //open the new dataset creation flow
    dispatch(resetStore());
    const newDatasetId = await createNewDataset();

    if (newDatasetId) {
      navigate(`/dataset/${newDatasetId}/create`);
    }
    return;
  };

  const renderHeaderTitle = () => {
    return (
      <div className={styles.headerLeft}>
        <span className={styles.headerText}>All Datasets</span>{" "}
        {datasets.length > 0 && (
          <span className={styles.datasetCountTitle}>
            Datasets{" "}
            <span className={styles.datasetCount}>{datasets.length}</span>
          </span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.headerContainer}>
      <div className={styles.upperRow}>
        {renderHeaderTitle()}
        {isPrivatePath ? (
          <PrivateDisplay handleButtonClick={handleButtonClick} />
        ) : (
          <PublicHeader isBig={true} />
        )}
      </div>
      <div className={styles.lowerRow}>
        <ProgressBarLoaderWrapper loading={isLoading} />
      </div>
    </div>
  );
}

function mapStatesToProps(state: State) {
  return {
    datasets: getDatasets(state),
    isLoading: getLoading(state),
  };
}

export default connect(mapStatesToProps)(Header);
